import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { duplicateProcess, deleteProcess, useEditor } from '@Services/Editor';

import useContextMenu from '@Hooks/useContextMenu';
import { ReactComponent as MoreIconSVG } from '@Assets/Svgs/ic_more.svg';
import TX from '@Components/Common/Text';
import Checkbox from '@Components/Common/Checkbox';
import { ContextMenu, Item } from '@Components/Common/ContextMenu';
import { MODAL_TYPES } from '@Services/Modal/Constants';
import { showModal } from '@Services/Modal';
import { useTriggerResizeSelector } from '@Services/CommonStatus/Selector';
import { setTriggerResize } from '@Services/CommonStatus';

const ProcessShowMoreButton = ({ processId, isEventFinish, handleEventFinishOfShowMoreButtonClick, snackBarRef }) => {
  const dispatch = useDispatch();
  const { isContextMenuVisible, handleShowContextMenuClick } = useContextMenu();
  const { processes } = useSelector(useEditor);
  const { resizeTrigger } = useSelector(useTriggerResizeSelector);

  const handleDuplicateProcessClick = useCallback(() => {
    if (processes?.length >= 500) {
      snackBarRef.current.show({
        text: '페이지는 최대 500개까지 생성 가능합니다.',
      });

      return;
    }
    dispatch(duplicateProcess({ processId }));
  }, [dispatch, processes]);

  // const handleDeleteProcessClick = useCallback(() => {
  //   console.log('asdasdas');
  //   dispatch(deleteProcess({ processId }));
  // }, [dispatch]);

  const handleDeleteProcessClick = useCallback(() => {
    dispatch(deleteProcess({ processId }));
    dispatch(setTriggerResize({ resizeTriggerBoolean: !resizeTrigger }));
  }, [dispatch, processId, resizeTrigger]);

  const openPageMoveModal = () => {
    dispatch(
      showModal({
        type: MODAL_TYPES.PAGE_MOVE,
        modalProps: {
          currentProcessId: processId,
        },
      }),
    );
  };
  return (
    <MoreButton onClick={event => handleShowContextMenuClick(event)}>
      <MoreIcon />

      {isContextMenuVisible && (
        <ContextMenu position={{ right: 0, top: 36 }}>
          <Item onClick={handleEventFinishOfShowMoreButtonClick}>
            <Checkbox
              id={`is_event_finish${processId}`}
              label="마지막 페이지"
              isChecked={isEventFinish}
              onChange={handleEventFinishOfShowMoreButtonClick}
            />
          </Item>
          <Item onClick={handleDuplicateProcessClick}>
            <ContextMenuItemText>페이지 복제</ContextMenuItemText>
          </Item>
          <Item
            style={{
              borderBottom: '1px solid #EBEBEB',
            }}
            onClick={openPageMoveModal}
          >
            <ContextMenuItemText>페이지 이동</ContextMenuItemText>
          </Item>
          <Item onClick={handleDeleteProcessClick}>
            <ContextMenuItemText isRed>페이지 삭제</ContextMenuItemText>
          </Item>
        </ContextMenu>
      )}
    </MoreButton>
  );
};

ProcessShowMoreButton.propTypes = {
  processId: PropTypes.number.isRequired,
  isEventFinish: PropTypes.bool.isRequired,
  handleEventFinishOfShowMoreButtonClick: PropTypes.func.isRequired,
};

const MoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;

  border: none;
  background: none;

  cursor: pointer;
`;

const MoreIcon = styled(MoreIconSVG)`
  width: 16px;
  height: 16px;
`;

const ContextMenuItemText = styled(TX.FootnoteM)`
  color: ${({ isRed, theme }) => (isRed ? theme.colors.danger : theme.colors.red)};
`;

export default ProcessShowMoreButton;

// import React, { useCallback } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import styled from 'styled-components';
// import PropTypes from 'prop-types';

// import { duplicateProcess, deleteProcess, useEditor } from '@Services/Editor';

// import useContextMenu from '@Hooks/useContextMenu';
// import { ReactComponent as MoreIconSVG } from '@Assets/Svgs/ic_more.svg';
// import TX from '@Components/Common/Text';
// import Checkbox from '@Components/Common/Checkbox';
// import { ContextMenu, Item } from '@Components/Common/ContextMenu';

// const ProcessShowMoreButton = ({ processId, isEventFinish, handleEventFinishOfShowMoreButtonClick }) => {
//   const dispatch = useDispatch();
//   const { isContextMenuVisible, handleShowContextMenuClick } = useContextMenu();
//   const { processes } = useSelector(useEditor);

//   const handleDuplicateProcessClick = useCallback(() => {
//     if (processes?.length >= 500) {
//       alert('페이지는 최대 500개까지 생성 가능합니다.');
//       return;
//     }
//     dispatch(duplicateProcess({ processId }));
//   }, [dispatch, processes]);

//   const handleDeleteProcessClick = useCallback(() => {
//     dispatch(deleteProcess({ processId }));
//   }, [dispatch]);

//   return (
//     <MoreButton onClick={event => handleShowContextMenuClick(event)}>
//       <MoreIcon />

//       {isContextMenuVisible && (
//         <ContextMenu position={{ right: 0, top: 36 }}>
//           <Item onClick={handleEventFinishOfShowMoreButtonClick}>
//             <Checkbox
//               id={`is_event_finish${processId}`}
//               label="마지막 페이지"
//               isChecked={isEventFinish}
//               onChange={handleEventFinishOfShowMoreButtonClick}
//             />
//           </Item>
//           <Item onClick={handleDuplicateProcessClick}>
//             <ContextMenuItemText>페이지 복제</ContextMenuItemText>
//           </Item>
//           <Item onClick={handleDuplicateProcessClick}>
//             <ContextMenuItemText>페이지 이동</ContextMenuItemText>
//           </Item>
//           <Item onClick={handleDeleteProcessClick}>
//             <ContextMenuItemText isRed>페이지 삭제</ContextMenuItemText>
//           </Item>
//         </ContextMenu>
//       )}
//     </MoreButton>
//   );
// };

// ProcessShowMoreButton.propTypes = {
//   processId: PropTypes.number.isRequired,
//   isEventFinish: PropTypes.bool.isRequired,
//   handleEventFinishOfShowMoreButtonClick: PropTypes.func.isRequired,
// };

// const MoreButton = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   width: 32px;
//   height: 32px;

//   border: none;
//   background: none;

//   cursor: pointer;
// `;

// const MoreIcon = styled(MoreIconSVG)`
//   width: 16px;
//   height: 16px;
// `;

// const ContextMenuItemText = styled(TX.FootnoteM)`
//   color: ${({ isRed, theme }) => (isRed ? theme.colors.danger : theme.colors.red)};
// `;

// export default ProcessShowMoreButton;
